import { processUploadedFiles, calculateFreelancerAmounts, prepareWorkingDates } from './InvoiceUtils';
import {
  getOtherArticlesUnit,
  diffInDates,
  getArticleNumber,
  isArticleTaxFree,
  convertFileToBase64,
} from '../../../../utils/commonFunc';
import { NEW_ARTICLES, AMOUNT_PER_UNIT} from '../../../../utils/constants';

export const processFileItems = (fileItems, fileBytes, values, userId) => {
  const file = [];
  let indexValue = 0;

  fileItems.forEach((item, index) => {
    // For Existing File
    if (item?.fileContent || item?.filesUploadid) {
      file.push({
        fileName: item?.fileName,
        fileContent: item?.fileContent,
        filesUploadid: item?.filesUploadid,
        invoiceApprovalId: item?.invoiceApprovalId,
        userId:
          values?.freelancer && values?.freelancer[index - 1] && index !== 0
            ? values?.freelancer[index - 1]?.userId
            : parseInt(userId, 10) || userId,
      });
    } else {
      file.push({
        fileName: item?.name,
        fileContent: fileBytes[indexValue].split(",")[1],
        userId:
          values?.freelancer && values?.freelancer[index - 1] && index !== 0
            ? values?.freelancer[index - 1]?.userId
            : parseInt(userId, 10) || userId,
      });
      indexValue++;
    }
  });

  return file;
};
